import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ContributionsList from './contributions_list'
import { publicContributionsListSelector } from 'redux/selectors/contributions'
import { getCampaignSelector } from 'redux/selectors/campaign'
import cssModules from 'react-css-modules'
import styles from './public_contributions_list.less'
import ChipInButton from '../pages/campaign/chip_in_button'
import { daysFromToday } from 'shared/helpers/datetime_helpers'
import { getI18n } from 'client/i18n'
import { formatMoney, getFullName } from 'client/griffin'
import PublicContributionRow from './rows/public_contribution_row'
import { POOLS_CAMPAIGN_TYPES } from 'shared/shared_consts'

const { CROWD_FUNDING } = POOLS_CAMPAIGN_TYPES
const i18n = getI18n('components/txns_list')

class UnboundPublicContributionsList extends React.Component {
  static propTypes = {
    campaignId: PropTypes.string.isRequired,
    contributions: PropTypes.array,
    txnsPerPage: PropTypes.number.isRequired,
    txnCount: PropTypes.number,
    goalRemaining: PropTypes.number,
    daysRemaining: PropTypes.number,
    currency: PropTypes.string.isRequired,
    ownerId: PropTypes.string.isRequired,
    ownerName: PropTypes.string.isRequired,
    canChipIn: PropTypes.bool.isRequired,
    preview: PropTypes.bool,
    onChipInClick: PropTypes.func,
    hideChipIn: PropTypes.bool,
    pledge: PropTypes.number,
    campaignType: PropTypes.string.isRequired,
    removeExistingCommentFlag: PropTypes.bool,
  }

  static defaultProps = {
    txnCount: 0,
    hideChipIn: false,
  }

  formattedAttention = () => {
    let stringId
    if (this.props.goalRemaining) {
      if (this.props.daysRemaining) {
        stringId = 'attention_goal_and_days_{days}'
      } else {
        stringId = 'attention_goal_only'
      }
    } else if (this.props.daysRemaining) {
      stringId = 'attention_days_only_{days}'
    }
    return stringId
      ? i18n(stringId, {
          amount: formatMoney(this.props.currency, this.props.goalRemaining, {
            removeTrailingZeros: true,
          }),
          days: this.props.daysRemaining,
        })
      : ''
  }

  shouldShowCallToChipIn = () => {
    return this.props.hideChipIn
      ? false
      : this.props.canChipIn && this.props.goalRemaining > 0
  }

  shouldSkipRenderingList = () => {
    return !this.shouldShowCallToChipIn() && !this.props.contributions
  }

  addPledgeToContributionList = () => {
    let contributionArray = this.props.contributions
      ? [...this.props.contributions]
      : []
    contributionArray.unshift({
      amount: this.props.pledge,
      anonymous: false,
      campaign_id: this.props.campaignId,
      contributor_id: this.props.ownerId,
      contributor_name: this.props.ownerName,
      contributor_photo: undefined,
      currency: this.props.currency,
      date: '',
      isPledge: true,
    })
    return contributionArray
  }

  render() {
    if (this.shouldSkipRenderingList()) return null
    let contributionCount = this.props.txnCount
    let contributionList = this.props.contributions
      ? [...this.props.contributions]
      : null
    if (this.props.campaignType === CROWD_FUNDING && this.props.pledge) {
      contributionList = this.addPledgeToContributionList()
      contributionCount++
    }
    const ContributionsCount = cssModules(
      ({ count }) => (
        <div styleName="contributions-count">
          {i18n('contributions_{count}', { count })}
        </div>
      ),
      styles
    )

    const ChipInCTA =
      this.shouldShowCallToChipIn() &&
      cssModules(
        ({ name, attentionMessage }) => (
          <div styleName="cta-container">
            <div styleName="help">
              <div styleName="help-details">
                <div styleName="help-title">
                  {i18n('help_organizer', { name })}
                </div>
                <div styleName="attention">{attentionMessage}</div>
              </div>
              <div styleName="help-action" className="hidden-xs">
                <ChipInButton
                  secondary={true}
                  reveresed={false}
                  small={true}
                  campaignId={this.props.campaignId}
                />
              </div>
            </div>
          </div>
        ),
        styles
      )

    return (
      <ContributionsList
        campaignId={this.props.campaignId}
        showTxnsDates={true}
        preview={this.props.preview}
        contributions={contributionList}
        topElement={<ContributionsCount count={contributionCount} />}
        bottomElement={
          ChipInCTA ? (
            <ChipInCTA
              name={this.props.ownerName}
              attentionMessage={this.formattedAttention()}
            />
          ) : (
            undefined
          )
        }
        rowElement={(contribution, key) => (
          <PublicContributionRow
            {...contribution}
            key={key}
            preview={this.props.preview}
            removeExistingCommentFlag={this.props.removeExistingCommentFlag}
          />
        )}
      />
    )
  }
}

export default connect((state, props) => {
  const campaign = getCampaignSelector(state, props)
  let daysRemaining
  if (campaign.end_date != null) {
    daysRemaining = daysFromToday(new Date(campaign.end_date))
  }

  let goalRemaining
  const currentValue = campaign.current_value + campaign.pledge
  if (campaign.goal != null && currentValue != null) {
    goalRemaining = campaign.goal - currentValue
  }

  return {
    contributions: publicContributionsListSelector(state, props),
    txnsPerPage: props.txnsPerPage || state.txns.txns_per_page,
    txnCount: campaign.txn_count,
    goalRemaining,
    daysRemaining,
    preview: campaign.preview,
    canChipIn: campaign.can_chip_in,
    pledge: campaign.pledge,
    currency: campaign.currency,
    campaignId: campaign.id,
    ownerId: campaign.owner.id,
    campaignType: campaign.campaign_type,
    removeExistingCommentFlag: state.flags && state.flags.removeExistingComment,
    ownerName:
      campaign.owner.business_name ||
      getFullName({
        givenName: campaign.owner.first_name,
        surname: campaign.owner.last_name,
      }),
  }
})(cssModules(UnboundPublicContributionsList, styles))
